module.exports = __webpack_public_path__ + "img/unpined.83e7604f.svg";